import { render, staticRenderFns } from "./CompletedBrokerDeals.vue?vue&type=template&id=3ae99244"
import script from "./CompletedBrokerDeals.vue?vue&type=script&lang=js"
export * from "./CompletedBrokerDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports